var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8064 4.70492C18.4436 4.07866 19.5197 4.53867 19.5073 5.43201L19.5011 5.87469C19.4976 6.12951 19.3969 6.37336 19.2196 6.55644L13.0152 12.9639C12.6267 13.3652 11.9847 13.3704 11.5897 12.9754L11.2134 12.5991C10.8205 12.2062 10.8232 11.5683 11.2195 11.1788L17.8064 4.70492Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2659 17.4288C19.4425 17.6147 19.541 17.8613 19.541 18.1177L19.541 18.542C19.541 19.4329 18.4639 19.879 17.8339 19.2491L11.2072 12.6224C10.8167 12.2319 10.8167 11.5987 11.2072 11.2082L11.5829 10.8325C11.9805 10.4349 12.6276 10.4432 13.015 10.8508L19.2659 17.4288Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73463 4.70492C6.09744 4.07866 5.02136 4.53867 5.03376 5.43201L5.03991 5.87469C5.04345 6.12951 5.14414 6.37336 5.32141 6.55644L11.5258 12.9639C11.9144 13.3652 12.5563 13.3704 12.9513 12.9754L13.3276 12.5991C13.7206 12.2062 13.7178 11.5683 13.3215 11.1788L6.73463 4.70492Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2751 17.4288C5.09848 17.6147 5 17.8613 5 18.1177L5 18.542C5 19.4329 6.07714 19.879 6.70711 19.2491L13.3338 12.6224C13.7243 12.2319 13.7243 11.5987 13.3338 11.2082L12.9581 10.8325C12.5605 10.4349 11.9134 10.4432 11.5261 10.8508L5.2751 17.4288Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.cb399751.svg";
export { ForwardRef as ReactComponent };